import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import clsx from "clsx";

const TextAreaField = ({
  id,
  label,
  placeholder,
  control,
  rules = {},
  error,
  errorMessages = {},
  disabled = false,
  rows = 4,
  className = "",
}) => {
  const errorMessage = error?.type ? errorMessages[error.type] : null;

  return (
    <div className={clsx("group flex w-full flex-col", className)}>
      <label
        htmlFor={id}
        className="mb-1 text-sm font-medium text-gray-700 group-has-[textarea[aria-invalid=true]]:text-red-500"
      >
        {label}
      </label>

      <div
        className={clsx(
          "rounded-lg border border-gray-300 bg-white px-3 py-2",
          "group-has-[textarea:disabled]:bg-gray-100",
          "group-has-[textarea[aria-invalid=true]]:border-red-500",
        )}
      >
        <Controller
          name={id}
          control={control}
          rules={rules}
          render={({ field: { onChange, value, ...field } }) => (
            <textarea
              id={id}
              placeholder={placeholder}
              disabled={disabled}
              value={value}
              onChange={onChange}
              aria-invalid={!!error}
              rows={rows}
              className="peer w-full resize-none bg-transparent text-sm outline-none"
              {...field}
            />
          )}
        />
      </div>

      {errorMessage && (
        <span className="mt-1 text-xs text-red-500">{errorMessage}</span>
      )}
    </div>
  );
};

export default TextAreaField;
TextAreaField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  control: PropTypes.object.isRequired,
  rules: PropTypes.object,
  error: PropTypes.object,
  errorMessages: PropTypes.object,
  disabled: PropTypes.bool,
  rows: PropTypes.number,
  className: PropTypes.string,
};
